import React from 'react'
import { useHistory } from 'react-router-dom'
import { useTaskAPI } from '@SonarCX/providers/TaskAPIProvider'
import { Routes } from '@SonarCX/Routes'

import TaskCard from '@SonarCX/pages/Tasks/Tabs/CardsTab/TaskCard'

import useStyles from './../../styles'

const HomeTasks = ({ latestTasks }) => {
  const history = useHistory()
  const { tasks: allTasks, loaded: tasksLoaded, loadTask } = useTaskAPI()
  const [fullTasks, setFullTasks] = React.useState([])

  const classes = useStyles()

  const handleClick = React.useCallback(
    (id: string) => {
      // Go to task
      history.push(`${Routes.TASKS}/${id}`)
    },
    [history]
  )

  // Gets the full tasks
  React.useEffect(() => {
    if (!tasksLoaded) {
      return
    }

    for (const latestTask of latestTasks) {
      const foundTask = allTasks[latestTask]
      if (foundTask && foundTask.id) {
        if (fullTasks.find(task => task.id === foundTask.id)) continue
        setFullTasks(old => [...old, foundTask].filter(Boolean))
      } else {
        loadTask(latestTask)
      }
    }
  }, [tasksLoaded, latestTasks, allTasks, loadTask, fullTasks])

  return (
    <>
      <h5 className={classes.sectionHeader}>Recent tasks</h5>

      <div className={classes.dataContainer}>
        {fullTasks.map(task => (
          <TaskCard
            key={task.id}
            task={task}
            containerID=''
            onClick={() => handleClick(task.id)}
            hideDragHandle
          />
        ))}
      </div>
    </>
  )
}
export default HomeTasks
